import { DialogContent } from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import DateHelper from "core/DateHelper";
import { DetailIcon, EditIcon, ApproveIcon } from "core/Icons";
import PropTypes, { bool, func } from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import {
   GenericDateInput,
   GenericDialog,
   GenericDialogActions,
   GenericExpansionPanel,
   GenericGrid,
   GenericLabel,
   GenericNumberInput,
   GenericPage,
   GenericSelectInput,
   GenericTextInput,
   GenericTitle,
   GenericAlert,
} from "views/Components/Generic";
import GridButton from "views/Components/GridButton";
import LoadingComponent from "views/Components/LoadingComponent";
import ParameterComponent from "views/Components/ParameterComponent";
import { Direction, GridColumnType, ProgramCodes } from "views/Constants/Constant";
import MessageDetail from "views/WireTransfer/CreateWireTransfer/MessageDetail";
import IncomingWireDetail from "views/Components/WireTransfer/IncomingWireDetail";
import {
   GetIncomingWireColumns,
   GetGeneralWireColumns,
} from "views/Backoffice/ClearingSettlement/WireTransfer/Common/IncomingWireColumns";

class OutgoingWireTransfers extends GenericPage {
   constructor(props) {
      super(props);

      this.IsBackOffice = ClientHelper.IsBackOffice();
      this.sortedName = { Member: "Name" };
      this.emptyObject = {};
      this.renderItemUniqueClient = {};
      this.renderItemAccount = {};

      this.approvalInProgress = false;

      this.incomingColumns = GetIncomingWireColumns();
      this.generalColumns = GetGeneralWireColumns();

      this.defaultMessageModel = {
         CustomerName: null,
         AccountNumber: null,
         DateOfRequest: null,
         CreationDate: null,
         ValueDate: null,
         BeneficiaryCompanyName: null,
         BeneficiaryFirstName: null,
         BeneficiaryLastName: null,
         BeneficiaryAddress: null,
         BeneficiaryAddress2: null,
         CustomerAddress: null,
         BeneficiaryCountry: null,
         BeneficiaryCity: null,
         BeneficiaryProvince: null,
         BeneficiaryPostalCode: null,
         BeneficiaryBankCountry: null,
         BeneficiaryBankPostalCode: null,
         BeneficiaryBankInstitution: null,
         Remittance: null,
         BeneficiaryAccountNumber: null,
         IntermediarySwiftCode: null,
         Amount: null,
         Currency: null,
         PurposeOfWire: null,
         Reference: null,
         BeneficiaryBank: null,
         BeneficiaryBankAddress: null,
         BeneficiaryBankAddress2: null,
         BeneficiaryBankCity: null,
         BeneficiaryBankProvince: null,
         TransitNumber: null,
      };

      this.defaultModel = {
         ClientId: null,
         FromDate: DateHelper.GetDate(),
         ToDate: DateHelper.GetDate(),
         DirectionParamValue: Direction.Incoming,
         MessageTypeId: null,
         SubStatusId: null,
         StatusId: null,
         AmountFrom: null,
         AmountTo: null,
         StatusParamCode: null,
         AccountId: null,
         UniqueClientId: null,
         SwiftReferenceNumber: null,
         TransactionReferenceNumber: null,
			OrganizationUniqueId: null
      };

      this.state = {
         Alert: null,
         model: { ...this.defaultModel },
         subStatusList: [],
         tempSubStatusList: [],
         transactionList: [],
         approvalTransactionList: [],
         incomingTransactionList: [],
         approvalIncomingTransactionLis: [],
         isLoading: false,
         isBackOffice: false,
         messageDetailModel: {},
         IsDomestic: {},
         detailDialog: false,
         incomingDetailDialog: false,
         approvalIncomingDetailDialog: false,
         approvalDialog: false,
         matchDialog: false,
         BeneficiaryInfo: [],
         ReceiverModel: {},
         ReceiverInfo: {},
         IncomingModel: {},
         IsUpdating: false,
      };
   }

   componentDidMount() {
      super.componentDidMount();
      this.Bind(this);
      var { isBackOffice } = this.state;
      var model = { ...this.state.model };

      isBackOffice = ClientHelper.IsBackOffice();
      if (!isBackOffice) {
         model.ClientId = ClientHelper.GetClientRowId();
         this.generalColumns.splice(1, 1);
      }
      this.setState({ model, isBackOffice });
      this.props.setAppLeftTitle("Wire Incoming Transfers");
      this.props.setAppCenterTitle("CLEARING & SETTLEMENT");
   }

   HideAlert() {
      this.setState({ Alert: null, isLoading: false });
   }

   HandleChange(name, newValue, data) {
      this.setState(function (state) {
         var model = state.model || {};
         model[name] = newValue;
         if (name == "StatusId") {
            if (newValue == -1) {
               model.StatusParamCode = null;
            } else if (data && data.ParameterValue == null) {
               model.StatusParamCode = null;
            } else if (data) {
               model.StatusParamCode = data.ParameterValue;
            }
         }
         return { model };
      });
   }

   HandleMessageChange(name, newValue) {
      const { messageDetailModel } = this.state;
      messageDetailModel[name] = newValue;
      this.setState({ messageDetailModel });
   }

   GetData() {
      /* this.ExecutePostRequest("/bankapi/v1.0/WireTransfer/TransactionSearch", this.state.model, (responseData) => {
         if (responseData.Item == null || responseData.Item.length < 1) {
            responseData.Item = [];
         }
         var approvalTransactionList = [];
         var transactionList = [];
         responseData.Item.forEach((element) => {
            if (element.IsApproval) {
               approvalTransactionList.push(element);
            } else {
               transactionList.push(element);
            }
         });
         this.setState({ transactionList, approvalTransactionList });
      }); */

      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/SearchWireTransferIncomingDetail",
         this.state.model,
         (responseData) => {
            if (responseData.Item == null || responseData.Item.length < 1) {
               responseData.Item = [];
            }
            var approvalIncomingTransactionLis = [];
            var incomingTransactionList = [];
            responseData.Item.forEach((element) => {
               if (element.IsBackOfficeApproved) {
                  approvalIncomingTransactionLis.push(element);
               } else {
                  incomingTransactionList.push(element);
               }
            });
            this.setState({ incomingTransactionList, approvalIncomingTransactionLis });
         }
      );
   }

   RenderOrganizationUniqueIdSelect = (d) => {
      if (window.OrganizationUniqueId != 5000) {
         const model = { ...this.state.model };
         model["OrganizationUniqueId"] = d.OrganizationUniqueId;
         this.setState({ model: model });
      }

      return d.OrganizationUniqueId + "-" + d.OrganizationName;
   };

   ClearModel() {
      const model = { ...this.state.model };
      var clientId = this.state.isBackOffice ? null : model.ClientId;
      var newModel = { ...this.defaultModel };
      newModel.ClientId = clientId;
      this.setState({ model: newModel, incomingTransactionList: [], approvalIncomingTransactionLis: [] });
   }

   /* HandleApproval() {
      const { messageDetailModel, model } = this.state;
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/ApproveIncomingWireTransfer",
         {
            TransactionWireTransferId: messageDetailModel.TransferId,
            TransferMessage: messageDetailModel,
            UniqueClientId: model.UniqueClientId,
            AccountId: model.AccountId,
         },
         (responseData) => {
            this.CloseDialog(this.GetData);
         }
      );
   } */

   /* HandleReject() {
      const { messageDetailModel } = this.state;
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/RejectIncomingWireTransfer",
         {
            IsCatmData: false,
            TransactionWireTransferId: messageDetailModel.TransferId,
         },
         (responseData) => {
            this.CloseDialog(this.GetData);
         }
      );
   } */

   /* HandleUnSettled() {
      const { messageDetailModel } = this.state;
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/RejectIncomingWireTransfer",
         {
            IsCatmData: true,
            TransactionWireTransferId: messageDetailModel.TransferId,
         },
         (responseData) => {
            this.CloseDialog(this.GetData);
         }
      );
   } */

   HandleEdit() {
      this.setState({ IsUpdating: true });
   }

   HandleClose() {
      this.CloseDialog();
   }

   CloseDialog(func = null) {
      this.defaultModel.FromDate = this.state.model.FromDate;
      this.defaultModel.ToDate = this.state.model.ToDate;
      if (func != null) {
         this.setState(
            {
               detailDialog: false,
               incomingDetailDialog: false,
               approvalIncomingDetailDialog: false,
               IsUpdating: false,
               approvalDialog: false,
               matchDialog: false,
               model: this.defaultModel,
               messageDetailModel: this.defaultMessageModel,
            },
            func
         );
      } else {
         this.setState({
            detailDialog: false,
            incomingDetailDialog: false,
            approvalIncomingDetailDialog: false,
            IsUpdating: false,
            approvalDialog: false,
            matchDialog: false,
            model: this.defaultModel,
            messageDetailModel: this.defaultMessageModel,
         });
      }
   }

   /* HandleOpenDetail(templateId, transferId, isApproval) {
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireBeneficiaryTemplate/SearchMessage",
         { Id: templateId },
         (responseData) => {
            const tempModel = { ...responseData.Item };
            tempModel.TransferId = transferId;
            tempModel.TempOrderingInstitutionSwiftCode = tempModel.OrderingInstitutionSwiftCode;
            this.setState({
               messageDetailModel: tempModel,
               detailDialog: true,
               approvalDialog: isApproval,
            });
         }
      );
   } */

   HandleCreateOrUpdate() {
      if (!this.Validate()) return;

      const { IncomingModel } = this.state;

      this.setState({ isLoading: true });

      const request = { ...IncomingModel };

      Proxy.POST(
         "/bankapi/v1.0/WireTransfer/CreateOrUpdateWireTransferIncomingDetail",
         request,
         (createResponseData) => {
            this.setState({ isLoading: false });

            if (!createResponseData.IsSucceeded) {
               this.ShowGenericMessage("error", "Error", createResponseData.ErrorDescription);
               return;
            }

            if (createResponseData.ErrorCode != "0") {
               this.ShowGenericMessage("error", "Rejected", createResponseData.ErrorDescription);
               return;
            }

            this.ShowGenericMessage("success", "Create", "Created successfully.");

            this.CloseDialog(this.GetData);
         }
      );
   }

   async HandleApprovalTransfer(Id) {
      if (this.approvalInProgress) return;
      this.approvalInProgress = true;

		this.setState({ isLoading: true });

      try {
         const responseData = await new Promise((resolve, reject) => {
            Proxy.POST(
               "/bankapi/v1.0/WireTransfer/ApprovalWireTransferIncoming",
               { Id },
               (response) => resolve(response),
               (error) => reject(error)
            );
         });

         if (!responseData.IsSucceeded) {
            this.ShowGenericMessage("error", "Error", responseData.ErrorDescription);
            return;
         }

         this.ShowGenericMessage("success", "Create", "Approval was successful.");
         this.GetData();
      } catch (error) {
         this.ShowGenericMessage("error", "Network Error", "Failed to connect to server.");
         console.error("Approval error:", error);
      } finally {
         this.approvalInProgress = false;
         this.setState({ isLoading: false });
      }
   }

   ShowConfirmMessage(Id) {
      const handleConfirm = async () => {
         await this.HandleApprovalTransfer(Id);
      };

      const handleCancel = () => {
         this.setState({ Alert: null, isLoading: false });
      };

      this.setState({
         Alert: (
            <GenericAlert
               Title="Caution"
               Message="Please confirm that you are willing to approve this transfer!"
               Type="warning"
               ShowCancel={true}
               OnCancel={handleCancel}
               OnConfirm={handleConfirm}
            />
         ),
      });
   }

   ValueChanged(name, newValue, data) {
      this.setState((prevState) => {
         const { IncomingModel } = this.state;
         let updatedReceiverModel = { ...prevState.ReceiverModel };
         IncomingModel[name] = newValue;

         if (name === "WireIncomingBeneficiaryId" && data != null) {
            updatedReceiverModel = { ...data };
         }

         if (name === "OrderingCountryId") {
            IncomingModel.OrderingProvinceId = null;
            IncomingModel.OrderingCityId = null;
         }

         if (name === "SendingFICountryId") {
            if (data?.ISO2 == "CA") {
               IncomingModel.IsDomestic = true;
            } else {
               IncomingModel.IsDomestic = false;
            }
         }

         return {
            IncomingModel,
            ReceiverModel: updatedReceiverModel,
         };
      });
   }

   HandleOpenIncomingDetail(Id, continueWith = null) {
      this.HandleOpenIncomingDetailGeneric(Id, "incomingDetailDialog", continueWith);
   }

   HandleOpenApprovalIncomingDetail(Id, continueWith = null) {
      this.HandleOpenIncomingDetailGeneric(Id, "approvalIncomingDetailDialog", continueWith);
   }

   HandleOpenIncomingDetailGeneric(Id, dialogKey, continueWith = null) {
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/SearchWireTransferIncomingDetailById",
         { Id },
         (responseData) => {
            this.setState({ IncomingModel: { ...responseData.Item }, [dialogKey]: true }, continueWith);
            if (responseData.Item !== null) {
               this.BeneficiaryInfo(responseData.Item.UniqueClientId);
               this.ReceiverInfo(responseData.Item.OrganizationUniqueId, responseData.Item.WireIncomingBeneficiaryId);
            }
         }
      );
   }

   BeneficiaryInfo(Id, continueWith = null) {
      this.ExecutePostRequest(
         "/bankapi/v1.0/WireTransfer/SearchIncomingWireBeneficiaryAccounts",
         { Id },
         (responseData) => {
            this.setState({ BeneficiaryInfo: { ...responseData.Item } }, continueWith);
         }
      );
   }

   ReceiverInfo(Id, ReceiverId, continueWith = null) {
      this.ExecutePostRequest("/bankapi/v1.0/WireTransfer/SearchIncomingWireReceiverInfo", { Id }, (responseData) => {
         const receiverInfo = responseData.Item || [];

         const receiverModel = receiverInfo.find((record) => record.Id === ReceiverId) || null;

         this.setState({ ReceiverInfo: receiverInfo, ReceiverModel: receiverModel }, continueWith);
      });
   }

   Validate() {
      const { IncomingModel } = this.state;
      var messages = [];

		if (this.approvalInProgress && !IncomingModel.WireIncomingBeneficiaryId) messages.push("Receiver cannot be null.");
      if (!IncomingModel.WireTransactionDate) messages.push("Date Request cannot be null.");
      if (!IncomingModel.Amount || IncomingModel.Amount <= 0) messages.push("Amount cannot be equal to 0 or less.");
      if (!IncomingModel.WirePurpose) messages.push("Purpose of Wire cannot be null.");
      if (!IncomingModel.AccountNumber || IncomingModel.AccountNumber < 1)
         messages.push("Beneficiary Account Number cannot be empty!");
      if (!IncomingModel.OrderingClientName) messages.push("Ordering Client Name cannot be null.");
      if (!IncomingModel.OrderingCountryId) messages.push("Ordering Country cannot be null.");
      if (!IncomingModel.OrderingProvinceId) messages.push("Ordering Province cannot be null.");
      if (!IncomingModel.OrderingCityId) messages.push("Ordering City cannot be null.");
      if (!IncomingModel.OrderingAddressLine1) messages.push("Address Line 1 cannot be null.");
      if (!IncomingModel.OrderingZipCode) messages.push("Postal Code cannot be null.");
      if (!IncomingModel.OrderingSourceAccountNumber) messages.push("Ordering Source Account Number cannot be null.");
      if (!IncomingModel.InternationalBankCountryId) messages.push("International Bank Country cannot be null.");
      if (!IncomingModel.SendingFI) messages.push("Sending Financial Institution cannot be null.");
      if (!IncomingModel.IsDomestic && !IncomingModel.SendingFISwiftCode) messages.push("Sending FI Swift Code cannot be null.");
      if (!IncomingModel.SendingFICountryId) messages.push("Sending FI Country cannot be null.");
      if (!IncomingModel.SendingFIAddress) messages.push("Sending FI Address cannot be null.");

      if (messages.length > 0) {
         this.ShowGenericMessage(
            "warning",
            "Please fill required fields!",
            messages.map((x, i) => <div key={i}>{x}</div>)
         );
         return false;
      }

      return true;
   }

   GetRenderItemUniqueClient = (x) => {
      this.renderItemUniqueClient = `${x.Name} - ${x.UniqueClientId}`;
      return this.renderItemUniqueClient;
   };

   GetRenderItemAccount = (x) => {
      this.renderItemAccount = `${x.AccountNumber} - ${x.AccountName}`;
      return this.renderItemAccount;
   };

   HandleMatchDialog = () => {
      this.setState({ matchDialog: false });
   };

   render() {
      const { Disabled, classes } = this.props;
      const { isLoading, IsLoading, Alert } = this.state;
      const {
         model,
         isBackOffice,
         messageDetailModel,
         matchDialog,
         detailDialog,
         incomingDetailDialog,
         approvalIncomingDetailDialog,
         approvalDialog,
         approvalTransactionList,
         transactionList,
         incomingTransactionList,
         approvalIncomingTransactionLis,
         BeneficiaryInfo,
         ReceiverInfo,
         ReceiverModel,
         IncomingModel,
         IsUpdating,
      } = this.state;

      /* const renderColumns = [
         {
            Header: "Actions",
            accessor: "Actions",
            Cell: (row) => (
               <div>
                  <GridButton
                     Icon={DetailIcon}
                     tooltip="Message Detail"
                     Disabled={Disabled}
                     OnClick={() => this.HandleOpenDetail(row.original.MessageId, 0, false)}
                  />
                  <GridButton
                     Icon={EditIcon}
                     tooltip="BSO Approval"
                     Disabled={Disabled}
                     OnClick={() => this.HandleOpenDetail(row.original.MessageId, row.original.WireTransferId, true)}
                  />
               </div>
            ),
         },
         ...this.generalColumns,
      ]; */

      const renderIncomingColumns = [
         {
            Header: "Actions",
            accessor: "Actions",
            Cell: (row) => (
               <div>
                  <GridButton
                     Icon={DetailIcon}
                     tooltip="Detail"
                     Disabled={Disabled}
                     OnClick={() => this.HandleOpenIncomingDetail(row.original.Id)}
                  />
                  <GridButton
                     Icon={ApproveIcon}
                     tooltip="Approval"
                     Disabled={Disabled}
                     OnClick={() => this.ShowConfirmMessage(row.original.Id)}
                  />
               </div>
            ),
         },
         ...this.incomingColumns,
      ];

      const renderAprovalIncomingColumns = [
         {
            Header: "Actions",
            accessor: "Actions",
            Cell: (row) => (
               <div>
                  <GridButton
                     Icon={DetailIcon}
                     tooltip="Detail"
                     Disabled={Disabled}
                     OnClick={() => this.HandleOpenApprovalIncomingDetail(row.original.Id)}
                  />
               </div>
            ),
         },
         {
            Header: "Approval Date",
            accessor: "ApprovalDate",
            type: GridColumnType.DateUtc,
         },
         ...this.incomingColumns,
         {
            Header: "Reference Number",
            accessor: "ReferenceNumber",
         },
      ];

      /* const renderTransactionColumns = [
         {
            Header: "Actions",
            accessor: "Actions",
            Cell: (row) => (
               <div>
                  <GridButton
                     Icon={DetailIcon}
                     tooltip="Message Detail"
                     Disabled={Disabled}
                     OnClick={() => this.HandleOpenDetail(row.original.MessageId, 0, false)}
                  />
               </div>
            ),
         },
         {
            Header: "Benefeciary Name",
            accessor: "BankBeneficiaryName",
         },
         {
            Header: "Beneficiary Wallet Number",
            accessor: "BankBeneficaryAccountNumber",
         },
         ...this.generalColumns,
      ]; */
      return (
         <div>
            {Alert}
            <LoadingComponent Show={isLoading || IsLoading} />
            {/* <GenericDialog open={detailDialog} maxWidth="xl" onBackdropClick={this.HandleClose}>
               <DialogContent>
                  <h4 style={{ color: "black", textAlign: "center" }}>
                     <b>Transaction Details</b>
                  </h4>
                  <br />
                  <MessageDetail
                     CustomerName={messageDetailModel.CustomerName}
                     AccountNumber={messageDetailModel.AccountNumber}
                     DateOfRequest={messageDetailModel.DateOfRequest}
                     CreationDate={messageDetailModel.CreationDate}
                     ValueDate={messageDetailModel.ValueDate}
                     BeneficiaryName={messageDetailModel.BeneficiaryName}
                     BeneficiaryAddress={messageDetailModel.BeneficiaryAddress}
                     BeneficiaryAddress2={messageDetailModel.BeneficiaryAddress2}
                     CustomerAddress={messageDetailModel.CustomerAddress}
                     BeneficiaryCountry={messageDetailModel.BeneficiaryCountry}
                     BeneficiaryCity={messageDetailModel.BeneficiaryCity}
                     BeneficiaryProvince={messageDetailModel.BeneficiaryProvince}
                     BeneficiaryPostalCode={messageDetailModel.BeneficiaryPostalCode}
                     BeneficiaryBankCountry={messageDetailModel.BeneficiaryBankCountry}
                     BeneficiaryBankPostalCode={messageDetailModel.BeneficiaryBankPostalCode}
                     BeneficiaryBankInstitution={messageDetailModel.BeneficiaryBankInstitution}
                     Remittance={messageDetailModel.Remittance}
                     BeneficiaryAccountNumber={messageDetailModel.BeneficiaryAccountNumber}
                     IntermediarySwiftCode={messageDetailModel.IntermediarySwiftCode}
                     Amount={messageDetailModel.Amount}
                     Currency={messageDetailModel.Currency}
                     PurposeOfWire={messageDetailModel.PurposeOfWire}
                     Reference={messageDetailModel.Reference}
                     BeneficiaryBank={messageDetailModel.BeneficiaryBank}
                     BeneficiaryBankAddress={messageDetailModel.BeneficiaryBankAddress}
                     BeneficiaryBankAddress2={messageDetailModel.BeneficiaryBankAddress2}
                     BeneficiaryBankCity={messageDetailModel.BeneficiaryBankCity}
                     BeneficiaryBankProvince={messageDetailModel.BeneficiaryBankProvince}
                     TransitNumber={messageDetailModel.TransitNumber}
                     BeneficiaryIdentifier={messageDetailModel.BeneficiaryIdentifier}
                     BeneficiaryBankPartyIdentifier={messageDetailModel.BeneficiaryBankPartyIdentifier}
                     OrderingInstitutionSwiftCode={messageDetailModel.OrderingInstitutionSwiftCode}
                     TempOrderingInstitutionSwiftCode={messageDetailModel.TempOrderingInstitutionSwiftCode}
                     SenderName={messageDetailModel.SenderName}
                     SenderAccountNumber={messageDetailModel.SenderAccountNumber}
                     SenderSwiftCode={messageDetailModel.SenderSwiftCode}
                     SenderAddress={messageDetailModel.SenderAddress}
                     SenderAdditionalInformation={messageDetailModel.SenderAdditionalInformation}
                     OrderingInstitutionPartyIdentifier={messageDetailModel.OrderingInstitutionPartyIdentifier}
                     OrderingInstitutionAddress={messageDetailModel.OrderingInstitutionAddress}
                     LastUser={messageDetailModel.LastUser}
                     SubStatus={messageDetailModel.SubStatus}
                     ValueChanged={this.HandleMessageChange}
                     Disabled={true}
                  />
                  <br />
               </DialogContent>
               <GenericDialogActions>
                  {approvalDialog && (
                     <Button size="sm" onClick={() => this.setState({ matchDialog: true })}>
                        Approve
                     </Button>
                  )}
                  {approvalDialog && (
                     <Button size="sm" onClick={this.HandleReject}>
                        Reject
                     </Button>
                  )}
                  {approvalDialog && (
                     <Button size="sm" onClick={this.HandleUnSettled}>
                        Old System
                     </Button>
                  )}
                  <Button size="sm" onClick={this.HandleClose}>
                     Close
                  </Button>
               </GenericDialogActions>
            </GenericDialog> */}

            <GenericDialog open={incomingDetailDialog} maxWidth="xl" onBackdropClick={this.HandleClose}>
               <DialogContent>
                  <h4 style={{ color: "black", textAlign: "center" }}>
                     <b>Incoming Wire Transfer Details</b>
                  </h4>
                  <br />
                  <IncomingWireDetail
                     BeneficiaryInfo={BeneficiaryInfo}
                     Model={IncomingModel}
                     ReceiverInfo={ReceiverInfo}
                     ReceiverModel={ReceiverModel}
                     ValueChanged={this.ValueChanged}
                     IsUpdating={IsUpdating}
                  />
               </DialogContent>
               <GenericDialogActions>
                  <Button size="sm" onClick={this.HandleEdit} color="info" disabled={IsUpdating}>
                     Edit
                  </Button>
                  <Button size="sm" onClick={this.HandleCreateOrUpdate} color="danger" disabled={!IsUpdating}>
                     Update
                  </Button>
                  <Button size="sm" onClick={this.HandleClose}>
                     Close
                  </Button>
               </GenericDialogActions>
            </GenericDialog>

            <GenericDialog open={approvalIncomingDetailDialog} maxWidth="xl" onBackdropClick={this.HandleClose}>
               <DialogContent>
                  <h4 style={{ color: "black", textAlign: "center" }}>
                     <b>Approved Incoming Wire Transfer Details</b>
                  </h4>
                  <br />
                  <IncomingWireDetail
                     BeneficiaryInfo={BeneficiaryInfo}
                     Model={IncomingModel}
                     ReceiverInfo={ReceiverInfo}
                     ReceiverModel={ReceiverModel}
                     ValueChanged={() => {}}
                     IsUpdating={IsUpdating}
                  />
               </DialogContent>
               <GenericDialogActions>
                  <Button size="sm" onClick={this.HandleClose}>
                     Close
                  </Button>
               </GenericDialogActions>
            </GenericDialog>

            {/* <GenericDialog open={matchDialog} maxWidth="md" fullWidth>
               <DialogContent className={classes.dialog}>
                  <GridContainer xs={12}>
                     <GridItem xs={8}>
                        <GenericSelectInput
                           Name="UniqueClientId"
                           LabelText="Client"
                           Method="POST"
                           Url="/bankapi/v1.0/BankCustomer/Search"
                           Parameter={this.emptyObject}
                           DataRoot="Item"
                           KeyValueMember="Id"
                           TextValueMember="Name"
                           RenderItem={this.GetRenderItemUniqueClient}
                           Sorted={this.sortedName}
                           Value={model.UniqueClientId}
                           ValueChanged={this.HandleChange}
                        />

                        <GenericSelectInput
                           key={model.UniqueClientId}
                           Name="AccountId"
                           LabelText="Wallet"
                           Method="POST"
                           Url="/bankapi/v1.0/Account/GetAllAccountByUniqueClient"
                           Parameter={{
                              UniqueClientId: model.UniqueClientId,
                           }}
                           DataRoot="Item"
                           KeyValueMember="AccountId"
                           TextValueMember="AccountNumber"
                           RenderItem={this.GetRenderItemAccount}
                           Sorted={{ Member: "AccountNumber" }}
                           Value={model.AccountId}
                           ValueChanged={this.HandleChange}
                        />
                     </GridItem>
                     <GridItem style={{ visibility: "hidden" }}>
                        <GenericTextInput LabelText="Empty" />

                        <GenericTextInput LabelText="Empty" />
                        <GenericTextInput LabelText="Empty" />
                        <GenericTextInput LabelText="Empty" />
                     </GridItem>

                     <GenericLabel
                        Text={"Are you sure you want to enter this transaction ?"}
                        Bold={true}
                        FontSize="20ox"
                     />
                  </GridContainer>
               </DialogContent>
               <GenericDialogActions>
                  <Button size="sm" onClick={this.HandleApproval}>
                     Confirm
                  </Button>
                  <Button size="sm" onClick={() => this.setState({ matchDialog: false })}>
                     Close
                  </Button>
               </GenericDialogActions>
            </GenericDialog> */}

            <ButtonToolbar
               ButtonList={[
                  { Code: "Search", OnClick: this.GetData, Disabled: Disabled },
                  { Code: "Clear", OnClick: this.ClearModel, Disabled: Disabled },
               ]}
               menuId={this.props.menuId}
               ApprovalData={this.props.ApprovalData}
               After={this.props.After}
            />
            <Card>
               <CardBody>
                  <GenericExpansionPanel IsActive={true}>
                     <GridContainer>
                        <GridItem xs={4}>
                           <GridContainer>
                              <GridItem xs={12}>
                                 <GenericSelectInput
                                    key={this.state.IsClientComponent}
                                    Name="OrganizationUniqueId"
                                    LabelText="Organization"
                                    Value={model.OrganizationUniqueId || ""}
                                    DataRoot="Item"
                                    ValueChanged={this.HandleChange}
                                    KeyValueMember="OrganizationUniqueId"
                                    TextValueMember="OrganizationUniqueId"
                                    Url="/bankapi/v1.0/OrganizationInfo/GetAll"
                                    Method="POST"
                                    RenderItem={this.RenderOrganizationUniqueIdSelect}
                                    Parameter={{}}
                                    Disabled={Disabled || !this.IsBackOffice}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericSelectInput
                                    Name="ClientId"
                                    LabelText="Client"
                                    Method="POST"
                                    Url="/bankapi/v1.0/BankCustomer/Search"
                                    Parameter={{}}
                                    DataRoot="Item"
                                    KeyValueMember="Id"
                                    RenderItem={(d) => `${d.UniqueClientId} - ${d.Name}`}
                                    Value={model.ClientId || ""}
                                    ValueChanged={this.HandleChange}
                                    All
                                    CanClear
                                    Disabled={!isBackOffice}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericDateInput
                                    Name="FromDate"
                                    LabelText="From Date"
                                    Utc={true}
                                    Value={model.FromDate == null || undefined ? "" : model.FromDate}
                                    ValueChanged={this.HandleChange}
                                    MaxDate={model.ToDate || DateHelper.GetDate()}
                                    IncludeTime={false}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericDateInput
                                    Name="ToDate"
                                    LabelText="To Date"
                                    Utc={true}
                                    Value={model.ToDate == null || undefined ? "" : model.ToDate}
                                    ValueChanged={this.HandleChange}
                                    MinDate={model.FromDate == null ? null : model.FromDate}
                                    MaxDate={DateHelper.GetDate()}
                                    IncludeTime={false}
                                 />
                              </GridItem>
                           </GridContainer>
                        </GridItem>
                        <GridItem xs={4}>
                           <GridContainer>
                              <GridItem xs={12}>
                                 <ParameterComponent
                                    All
                                    Name="StatusId"
                                    Value={model.StatusId}
                                    LabelText="Status"
                                    ParameterCode="WireStatus"
                                    ValueChanged={this.HandleChange}
                                    Disabled={Disabled}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <ParameterComponent
                                    key={"wiresubstatus_" + model.StatusId}
                                    Name="SubStatusId"
                                    Value={model.SubStatusId}
                                    LabelText="Sub-Status"
                                    ParameterCode="WireSubStatus"
                                    ParameterValue2={model.StatusParamCode}
                                    ValueChanged={this.HandleChange}
                                    Disabled={Disabled}
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    Name="TransactionReferenceNumber"
                                    LabelText="Transaction Reference Number"
                                    Value={model.TransactionReferenceNumber}
                                    ValueChanged={this.HandleChange}
                                 />
                              </GridItem>
                           </GridContainer>
                        </GridItem>
                        <GridItem xs={4}>
                           <GridContainer>
                              <GridItem xs={12}>
                                 <GenericNumberInput
                                    Name="AmountFrom"
                                    LabelText="Amount From"
                                    Value={model.AmountFrom == null ? "" : model.AmountFrom}
                                    ValueChanged={this.HandleChange}
                                    Prefix="$"
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericNumberInput
                                    Name="AmountTo"
                                    LabelText="Amount To"
                                    Value={model.AmountTo == null ? "" : model.AmountTo}
                                    ValueChanged={this.HandleChange}
                                    Prefix="$"
                                 />
                              </GridItem>
                              <GridItem xs={12}>
                                 <GenericTextInput
                                    Name="SwiftReferenceNumber"
                                    LabelText="Swift Reference Number"
                                    Value={model.SwiftReferenceNumber}
                                    ValueChanged={this.HandleChange}
                                 />
                              </GridItem>
                           </GridContainer>
                        </GridItem>
                        <br />
                     </GridContainer>
                  </GenericExpansionPanel>
               </CardBody>
            </Card>
            <Card className="no-radius">
               <CardBody>
                  <CardHeader>
                     <GenericTitle text={"Incoming Wire Transfer List"} />
                  </CardHeader>
                  <GridItem xs={12}>
                     <GridItem>
                        <GenericGrid
                           Data={incomingTransactionList}
                           Sorted={[{ id: "WireRequestDate", desc: true }]}
                           Columns={renderIncomingColumns}
                           PageSize={25}
                           ShowPagination={true}
                        />
                     </GridItem>
                  </GridItem>
               </CardBody>
            </Card>
            <Card className="no-radius">
               <CardBody>
                  <CardHeader>
                     <GenericTitle text={"Approved Incoming Wire Transfer List"} />
                  </CardHeader>
                  <GridItem xs={12}>
                     <GridItem>
                        <GenericGrid
                           Data={approvalIncomingTransactionLis}
                           Sorted={[{ id: "ApprovalDate", desc: true }]}
                           Columns={renderAprovalIncomingColumns}
                           PageSize={25}
                           ShowPagination={true}
                        />
                     </GridItem>
                  </GridItem>
               </CardBody>
            </Card>
            {/* <Card className="no-radius">
               <CardBody>
                  <CardHeader>
                     <GenericTitle text={"BSO Approval List"} />
                  </CardHeader>
                  <GridItem xs={12}>
                     <GridItem>
                        <GenericGrid
                           Data={approvalTransactionList}
                           Sorted={[{ id: "DateRequest", desc: true }]}
                           Columns={renderColumns}
                           ProgramCode={ProgramCodes.Bank_Programs_Bank_Account}
                           ShowPagination={true}
                        />
                     </GridItem>
                  </GridItem>
               </CardBody>
            </Card> */}
            {/* <Card className="no-radius">
               <CardBody>
                  <CardHeader>
                     <GenericTitle text={"Transaction List"} />
                  </CardHeader>
                  <GridItem xs={12}>
                     <GridItem>
                        <GenericGrid
                           Data={transactionList}
                           Sorted={[{ id: "DateRequest", desc: true }]}
                           Columns={renderTransactionColumns}
                           ShowPagination={true}
                        />
                     </GridItem>
                  </GridItem>
               </CardBody>
            </Card> */}
         </div>
      );
   }
}

OutgoingWireTransfers.propTypes = {
   classes: PropTypes.object,
   handleOperationType: func,
   showQuestionMessage: func,
   setAppLeftTitle: func,
   setAppCenterTitle: func,
   Disabled: bool,
   ValueChanged: PropTypes.func,
   Model: PropTypes.object,
};

export default withArtifex(OutgoingWireTransfers, {});
